/**
 * Captura analítica de la propina (datos agregados): lo que vio y eligió el
 * cliente, en qué idioma y con qué tipo de móvil. No se le pide nada: todo
 * lo sabe ya el navegador. Sin datos personales. Viaja con la propina en
 * `tip.captura`; el servidor solo guarda lo previsto (utils/capturaPropina.js
 * del backend) y la tabla de hechos lo usa para el benchmark y el Índice.
 */

export function detectarDispositivo(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  const s = String(ua || "");
  if (/iPhone|iPad|iPod/i.test(s)) return "ios";
  if (/Android/i.test(s)) return "android";
  if (/Windows|Macintosh|Linux|CrOS/i.test(s)) return "escritorio";
  return "otro";
}

export function walletInstalada() {
  try {
    return (
      (typeof window !== "undefined" && window.matchMedia?.("(display-mode: standalone)")?.matches) ||
      (typeof navigator !== "undefined" && navigator.standalone === true)
    );
  } catch {
    return false;
  }
}

/**
 * @param {object} p
 * @param {Array<{import:number}>} p.opciones importes mostrados
 * @param {boolean} p.libre el cliente escribió su propio importe
 * @param {string} p.idioma idioma de la web (i18n.language)
 * @param {Date} p.opcionesVistasAt cuándo se mostraron (carga de la página)
 * @param {Date|null} p.importeElegidoAt primera vez que eligió un importe
 */
export function construirCaptura({ opciones = [], libre = false, idioma = "", opcionesVistasAt, importeElegidoAt }) {
  return {
    tipoOpciones: "importe",
    opcionesOfrecidas: opciones.map((o) => Number(o?.import)).filter((n) => Number.isFinite(n) && n > 0),
    opcionElegida: libre ? "libre" : "sugerida",
    idioma: String(idioma || "").split("-")[0].toLowerCase(),
    dispositivo: detectarDispositivo(),
    walletInstalada: !!walletInstalada(),
    opcionesVistasAt: opcionesVistasAt ? new Date(opcionesVistasAt).toISOString() : undefined,
    importeElegidoAt: importeElegidoAt ? new Date(importeElegidoAt).toISOString() : undefined,
    pagoIniciadoAt: new Date().toISOString(),
  };
}
